import { useNavigate } from 'react-router-dom';
import useMeta from '../../../hooks/useMeta';
import { useSignupBfEarlyMutation } from '../../../features/leadApiSlice';

export const BF_LEAD_CAMPAIGN = 'bf26_leadgen';
export const BF_THANK_YOU_PATH = '/black-friday/thank-you';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const useLeadSignup = () => {
  const navigate = useNavigate();
  const { metaEvent } = useMeta();
  const [signupBfEarly, { isLoading, isError }] = useSignupBfEarlyMutation();
  const status = isLoading ? 'submitting' : isError ? 'error' : 'idle';

  const validate = ({ firstName, email }) => {
    const errors = {};
    if (!firstName.trim()) errors.firstName = 'BF_LG_ErrName';
    if (!EMAIL_PATTERN.test(email.trim())) errors.email = 'BF_LG_ErrEmail';
    return errors;
  };

  const submit = async (values) => {
    if (isLoading) return;

    try {
      await signupBfEarly({
        firstName: values.firstName.trim(),
        email: values.email.trim().toLowerCase(),
      }).unwrap();
      localStorage.setItem('email', values.email.trim().toLowerCase());
      metaEvent('Lead');
      navigate(BF_THANK_YOU_PATH);
    } catch {
      return;
    }
  };

  return { status, validate, submit };
};

export default useLeadSignup;
